import { HsaFsaInlineLogo } from '@jouzen/ecom-components/icons/HsaFsaInlineLogo';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import Motion from '@/app/components/Motion';
import RichText from '@/app/components/RichText';
import { useHsaFsa } from '@/app/hooks/useHsaFsa';

const LogoComponent = () => (
  <HsaFsaInlineLogo
    className="inline-block -translate-y-px text-gray-450"
    data-cy="hsa-fsa-logo"
  />
);

export const StoreHeaderSection = () => {
  const t = useTranslations();
  const { isAvailable: HsaFsa } = useHsaFsa();

  return (
    <section
      className="flex flex-col items-center justify-center pt-48 pb-32"
      data-cy="store-header-section"
    >
      <Motion
        animate={{ opacity: 1, translateY: 0, filter: 'blur(0px)' }}
        initial={{ opacity: 0, translateY: 25, filter: 'blur(5px)' }}
        transition={{ delay: 0.25, duration: 1, type: 'tween' }}
      >
        <Typography
          className="flex flex-col justify-center text-center text-5xl text-balance hyphens-none md:px-6 md:text-7xl md:text-wrap lg:px-22 lg:text-9xl"
          font="serif"
          data-cy="store-header-title"
          Element="h1"
        >
          {t('oura_store_header')}
        </Typography>
      </Motion>
      {HsaFsa && (
        <Motion
          animate={{ opacity: 1, translateY: 0, filter: 'blur(0px)' }}
          initial={{ opacity: 0, translateY: 25, filter: 'blur(5px)' }}
          transition={{ delay: 0.7, duration: 1, type: 'tween' }}
        >
          <Typography
            className="py-4 text-center text-sm text-balance text-gray-450 lg:text-wrap"
            data-cy="store-header-hsa-subtitle"
          >
            <RichText
              messageKey="ring_membership_hsa"
              tValues={{
                logo: LogoComponent,
              }}
            />
          </Typography>
        </Motion>
      )}
    </section>
  );
};
